// import { initializeApp } from "firebase/app";
// import { getFirestore, doc, runTransaction, serverTimestamp } from "firebase/firestore";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";


// const firebaseConfig = {
//   apiKey: "AIzaSyAEsrHK3k5gCS7ZnXXlvsoqz0DZFKFwjTk",
//   authDomain: "pushnotification-26fdb.firebaseapp.com",
//   projectId: "pushnotification-26fdb",
//   storageBucket: "pushnotification-26fdb.firebasestorage.app",
//   messagingSenderId: "687591429394",
//   appId: "1:687591429394:web:2efc71c01eefc60035cfcb",
//   measurementId: "G-V2B83EBP07"
// };



// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// const db = getFirestore(app);
// export const messaging = getMessaging(app);



// // For FCM Token Request
// export const getFcmToken = async () => {
//   try {
//     const permission = await Notification.requestPermission();
//     if (permission !== "granted") return null;

//     const token = await getToken(messaging, {
//       vapidKey: "BAVE9PdQhTayMEIwvmmDkQ9ZSKDNcAW7nmkcVopCbEEvM4jX370bcwjNiwSfjKJ4mPDNiXpXSr_0m1Eoxk1bwaI"
//     });

//     return token;
//   } catch (err) {
//     return null;
//   }
// }

// export const onForegroundMessage = (cb) => {
//   return onMessage(messaging, cb);
// };

// export const notifyPatient = async (
//   patientId,
//   roomId,
//   doctorName,
//   doctorId
// ) => {
//   const callRef = doc(db, "calls", roomId); // 👈 roomId as docId

//   await runTransaction(db, async (tx) => {
//     const snap = await tx.get(callRef);

//     if (snap.exists()) {
//       // call already exists → do nothing
//       return;
//     }

//     tx.set(callRef, {
//       incomingCall: {
//         callerName: doctorName,
//         callerId: doctorId,
//         role: "doctor",
//         roomId,
//         receiverId: patientId,
//         status: 1, // ringing
//         createdAt: serverTimestamp()
//       }
//     });
//   });
// };

// export { app, db };

// ─────────────────────────────────────────────────────────────────────────────
// firebase.js  (shared config — identical for both apps)
// ─────────────────────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  getDoc,
  deleteDoc,
  runTransaction,
  serverTimestamp,
  query,
  collection,
  where,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAEsrHK3k5gCS7ZnXXlvsoqz0DZFKFwjTk",
  authDomain: "pushnotification-26fdb.firebaseapp.com",
  projectId: "pushnotification-26fdb",
  storageBucket: "pushnotification-26fdb.firebasestorage.app",
  messagingSenderId: "687591429394",
  appId: "1:687591429394:web:2efc71c01eefc60035cfcb",
  measurementId: "G-V2B83EBP07",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const messaging = getMessaging(app);

// ─── FCM ───────────────────────────────────────────────────────────────────
export const getFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;
    return await getToken(messaging, {
      vapidKey:
        "BAVE9PdQhTayMEIwvmmDkQ9ZSKDNcAW7nmkcVopCbEEvM4jX370bcwjNiwSfjKJ4mPDNiXpXSr_0m1Eoxk1bwaI",
    });
  } catch (err) {
    console.error("FCM Token Error", err);
    return null;
  }
};

export const onForegroundMessage = (cb) => onMessage(messaging, cb);

// ─── CALL STATUS ENUM ──────────────────────────────────────────────────────
export const CALL_STATUS = {
  RINGING: 1,
  IN_CALL: 2,
  REJECTED: -1,
  ENDED: -2,
};

// /**
//  * Create a call notification document in Firestore.
//  *
//  * Uses a transaction so that if a doc already exists for this roomId
//  * (e.g. an earlier call or a concurrent write), we skip silently.
//  *
//  * @param {object} params
//  * @param {string} params.callerId      - userId of the person who initiated the call
//  * @param {string} params.callerName    - display name of the caller
//  * @param {string} params.callerRole    - "doctor" | "patient"
//  * @param {string} params.receiverId    - userId of the other party
//  * @param {string} params.roomId        - appointmentId (used as Firestore doc ID)
//  */
// export const createCallNotification = async ({
//   callerId,
//   callerName,
//   callerRole,
//   receiverId,
//   roomId,
// }) => {
//   const callRef = doc(db, "calls", roomId);

//   await runTransaction(db, async (tx) => {
//     const snap = await tx.get(callRef);
//     // if (snap.exists()) {
//     //   // A record already exists — caller is already waiting or call is active.
//     //   // Do nothing; avoids duplicate notifications.
//     //   return;
//     // }
//     tx.set(callRef, {
//       incomingCall: {
//         callerName,
//         callerId,
//         role: callerRole,
//         roomId,
//         receiverId,
//         status: CALL_STATUS.RINGING,
//         createdAt: serverTimestamp(),
//       },
//     });
//   });
// };

/**
 * Create a call notification document in Firestore.
 *
 * Uses a transaction so that if a call is genuinely still active for this
 * roomId, we skip silently and avoid a duplicate notification.
 *
 * FIX: previously this skipped whenever a doc existed at all — including
 * a stale REJECTED/ENDED doc left behind from a prior call attempt on the
 * same appointment. That silently blocked every future call on that
 * appointment, in both directions, with no error surfaced anywhere.
 * Now we only skip if the existing doc is genuinely RINGING or IN_CALL.
 *
 * @param {object} params
 * @param {string} params.callerId      - userId of the person who initiated the call
 * @param {string} params.callerName    - display name of the caller
 * @param {string} params.callerRole    - "doctor" | "patient"
 * @param {string} params.receiverId    - userId of the other party
 * @param {string} params.roomId        - appointmentId (used as Firestore doc ID)
 */
export const createCallNotification = async ({
  callerId,
  callerName,
  callerRole,
  receiverId,
  roomId,
}) => {
  const callRef = doc(db, "calls", roomId);

  await runTransaction(db, async (tx) => {
    const snap = await tx.get(callRef);
    if (snap.exists()) {
      const existingStatus = snap.data()?.incomingCall?.status;
      // Only block if a call for this appointment is genuinely still live.
      // A leftover REJECTED/ENDED doc from a prior attempt must not block
      // a brand-new call for the same appointment.
      if (
        existingStatus === CALL_STATUS.RINGING ||
        existingStatus === CALL_STATUS.IN_CALL
      ) {
        return;
      }
    }
    tx.set(callRef, {
      incomingCall: {
        callerName,
        callerId,
        role: callerRole,
        roomId,
        receiverId,
        status: CALL_STATUS.RINGING,
        createdAt: serverTimestamp(),
      },
    });
  });
};


// ─── BACKWARD-COMPATIBLE ALIASES ──────────────────────────────────────────
// GiveConsent.jsx, UpcomingAppointments.jsx, and AppointmentTable.jsx still
// import the old names.  Re-export them here so those files compile without
// any changes.

/**
 * Patient app: patient initiates → notifies the doctor.
 * Alias of createCallNotification with role pre-filled as "patient".
 *
 * @param {string} patientId    callerId
 * @param {string} roomId       appointmentId
 * @param {string} patientName  callerName
 * @param {string} doctorId     receiverId
 */
export const notifyPatient = async (patientId, roomId, doctorName, doctorId) =>
  createCallNotification({
    callerId:  doctorId,
    callerName: doctorName,
    callerRole: "doctor",
    receiverId: patientId,
    roomId,
  });

/**
 * Doctor app: doctor initiates → notifies the patient.
 * Alias of createCallNotification with role pre-filled as "doctor".
 *
 * @param {string} patientId   receiverId
 * @param {string} roomId      appointmentId
 * @param {string} doctorName  callerName
 * @param {string} doctorId    callerId
 */
export const notifyDoctor = async (patientId, roomId, doctorName, doctorId) =>
  createCallNotification({
    callerId:   doctorId,
    callerName: doctorName,
    callerRole: "doctor",
    receiverId: patientId,
    roomId,
  });

// /**
//  * Delete the call document from Firestore.
//  * Only the original caller (matched by callerId) may delete it.
//  *
//  * @param {string} roomId        - Firestore doc ID (== appointmentId)
//  * @param {string} callerId      - The caller's userId to validate ownership
//  */
// export const deleteCallRecord = async (roomId, callerId) => {
//   if (!roomId || !callerId) return;
//   try {
//     const callRef = doc(db, "calls", roomId);
//     const snap = await getDoc(callRef);
//     if (!snap.exists()) return; // already gone — nothing to do

//     const storedCallerId = snap.data()?.incomingCall?.callerId;
//     if (storedCallerId !== callerId) {
//       // Not the caller; do not delete (receiver handles their own flow).
//       console.warn("deleteCallRecord: caller mismatch — skipped.");
//       return;
//     }
//     await deleteDoc(callRef);
//   } catch (err) {
//     console.error("deleteCallRecord error:", err);
//   }
// };

/**
 * Delete the call document from Firestore.
 *
 * FIX: previously this only allowed the ORIGINAL CALLER to delete the doc.
 * Since either side (doctor or patient) can be the caller depending on who
 * initiated, whenever the non-caller side left the call first (or the
 * caller's own cleanup never ran — tab closed, crash, etc.), the doc was
 * never deleted. That stale doc then permanently blocked every future call
 * attempt on that same appointment via createCallNotification's guard.
 * Now either participant (caller or receiver) may delete the doc when they
 * leave the call.
 *
 * @param {string} roomId          - Firestore doc ID (== appointmentId)
 * @param {string} currentUserId   - The user's own userId, to validate they
 *                                   were a participant in this call
 */
export const deleteCallRecord = async (roomId, currentUserId) => {
  if (!roomId || !currentUserId) return;
  try {
    const callRef = doc(db, "calls", roomId);
    const snap = await getDoc(callRef);
    if (!snap.exists()) return; // already gone — nothing to do

    const { callerId, receiverId } = snap.data()?.incomingCall || {};

    if (currentUserId !== callerId && currentUserId !== receiverId) {
      // Not a participant in this call — do not delete.
      console.warn("deleteCallRecord: user not a participant — skipped.");
      return;
    }
    await deleteDoc(callRef);
  } catch (err) {
    console.error("deleteCallRecord error:", err);
  }
};


/**
 * Listen for diet image upload notifications for this doctor.
 * Calls `onNotification(docId, data)` for each unseen upload.
 * Returns the unsubscribe function — call it on component unmount.
 *
 * @param {string}   doctorId
 * @param {function} onNotification  (docId, notificationData) => void
 */
export const listenDietImageUploads = (doctorId, onNotification) => {
  const q = query(
    collection(db, "dietImageUploads"),
    where("doctorId", "==", doctorId),
    where("seen", "==", false)
  );

  return onSnapshot(q, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        onNotification(change.doc.id, change.doc.data());
      }
    });
  });
};

/**
 * Mark a diet image upload notification as seen.
 */
export const markDietNotificationSeen = async (docId) => {
  try {
    await updateDoc(doc(db, "dietImageUploads", docId), { seen: true });
  } catch (err) {
    console.error("markDietNotificationSeen error:", err);
  }
};